import { render, staticRenderFns } from "./CRSearch.vue?vue&type=template&id=310165f6&scoped=true&"
import script from "./CRSearch.vue?vue&type=script&lang=js&"
export * from "./CRSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310165f6",
  null
  
)

export default component.exports